import { ColumnDefinition, Table, Text } from '@approvalmax/ui/src/components';
import { intl } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { noValue } from 'shared/constants';

import { messages } from './QBooksBudgetImpactDetailsPopupContent.messages';

export const getColumnDefinitions = (
    currency: string,
    lineAmountType: domain.LineAmountType,
    category?: string
): ColumnDefinition<domain.QBooksLineItem | domain.QBooksAccountLineItem>[] => [
    {
        name: messages.item,
        id: 'item',
        cellComponent: (props) => {
            const { item: tableLine } = props;

            const item = 'item' in tableLine ? tableLine.item?.text : undefined;

            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100'>
                        {item ?? noValue}
                    </Text>
                </Table.Cell>
            );
        },
    },
    {
        name: messages.description,
        id: 'description',
        cellComponent: (props) => {
            const { item } = props;

            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100' wrap>
                        {item.description ?? noValue}
                    </Text>
                </Table.Cell>
            );
        },
    },
    {
        name: messages.category,
        id: 'category',
        cellComponent: (props) => {
            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100'>
                        {category ?? noValue}
                    </Text>
                </Table.Cell>
            );
        },
        isEmpty: () => false,
    },
    {
        name: messages.qty,
        id: 'qty',
        textAlign: 'right',
        headerTextAlign: 'right',
        cellComponent: (props) => {
            const { item } = props;

            const value = 'qty' in item ? intl.formatNumber(item.qty ?? 0) : undefined;

            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100' wrap={false}>
                        {value ?? noValue}
                    </Text>
                </Table.Cell>
            );
        },
        isEmpty: (item) => ('qty' in item ? typeof item.qty !== 'number' : true),
    },
    {
        name: messages.rate,
        id: 'rate',
        textAlign: 'right',
        headerTextAlign: 'right',
        cellComponent: (props) => {
            const { item } = props;

            const isGross = lineAmountType === domain.LineAmountType.TaxInclusive;

            let value: string | undefined = undefined;

            if ('unitPrice' in item) {
                const rate = isGross ? item.unitPriceGross : item.unitPrice;

                value = intl.formatNumber(rate ?? 0);
            }

            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100' wrap={false}>
                        {value ?? noValue}
                    </Text>
                </Table.Cell>
            );
        },
        isEmpty: (item) => {
            if ('unitPrice' in item) {
                const isGross = lineAmountType === domain.LineAmountType.TaxInclusive;

                const rate = isGross ? item.unitPriceGross : item.unitPrice;

                return typeof rate !== 'number';
            }

            return true;
        },
    },
    {
        name: messages.tax,
        id: 'taxCode',
        cellComponent: (props) => {
            const { item } = props;

            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100'>
                        {item.taxCode?.text ?? noValue}
                    </Text>
                </Table.Cell>
            );
        },
    },
    {
        name: messages.amount({ currency }),
        id: 'amount',
        textAlign: 'right',
        headerTextAlign: 'right',
        cellComponent: (props) => {
            const { item } = props;

            return (
                <Table.Cell {...props}>
                    <Text font='label' fontSize='small' color='midnight100' wrap={false}>
                        {intl.formatNumber(item.amount ?? 0)}
                    </Text>
                </Table.Cell>
            );
        },
        isEmpty: (item) => typeof item.amount !== 'number',
    },
];
